import React from 'react';
import { connect } from 'react-redux';
import AbstractVideoTrack from '../AbstractVideoTrack';
import Video from './Video';
/**
 * Component that renders a video element for a passed in video track and
 * notifies the store when the video has started playing.
 *
 * @augments AbstractVideoTrack
 */
//@ts-ignore
class VideoTrack extends AbstractVideoTrack {
    /**
     * Renders the video element.
     *
     * @override
     * @returns {ReactElement}
     */
    render() {
        const { isLocalStudent, isPeerStudentTile, className, id, muted, videoTrack, style, eventHandlers, isFullScreen, nickname, showWaterMark, handlerFullScreen, handlerExitFullScreen,
        //@ts-ignore
         } = this.props;
        return (React.createElement(Video, { isLocalStudent: isLocalStudent, isPeerStudentTile: isPeerStudentTile, autoPlay: true, className: className, eventHandlers: eventHandlers, id: id, muted: muted, 
            //@ts-ignore
            onVideoPlaying: this._onVideoPlaying, style: style, showWaterMark: showWaterMark, isFullScreen: isFullScreen, videoTrack: videoTrack, nickname: nickname, handlerFullScreen: handlerFullScreen, handlerExitFullScreen: handlerExitFullScreen }));
    }
}
/**
 * Default values for {@code VideoTrack} component's properties.
 *
 * @static
 */
VideoTrack.defaultProps = {
    className: '',
    id: '',
};
export default connect()(VideoTrack);
